<template>
  <div v-if="showView">
    <header class="header fixed-top">
      <nav class="navbar navbar-light bg-light">
        <div class="container navbarCont" style="padding: 0">
          <a class="navbar-brand">
            <img src="../assets/logo3.png" class="logo" />
          </a>
          <form class="form-inline searchbox">
            <input
              type="text"
              class="navInput"
              placeholder="请输入关键字"
              placeholder-class="ipt"
            />
            <button class="navbtn" type="submit">
              <img src="../assets/search.png" class="searchico" />
              搜索
            </button>
          </form>
        </div>
      </nav>
      <nav
        class="navbar navbar-expand-lg navbar-light"
        :class="[scrollTop > 100 ? 'shadow' : '']"
        :style="{ background: backgroundColor }"
      >
        <div
          class="container navBox"
          style="display: flex; justify-content: flex-end"
        >
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarsExampleDefault"
            aria-controls="navbarsExampleDefault"
            aria-expanded="false"
            aria-label="Toggle navigation"
            @click="collapseNav"
          >
            <span class="navbar-toggler-icon">
              <img v-if="isCollapse" :src="bgimg1" />
              <img v-else :src="bgimg2" />
            </span>
          </button>

          <div
            class="collapse navbar-collapse"
            id="navbarsExampleDefault"
            style="justify-content: center"
          >
            <ul class="navbar-nav">
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/"
                  >首页</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/about"
                  >关于我们</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/product"
                  >产品中心</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/support"
                  >技术支持</router-link
                >
              </li>
              <li
                class="nav-item"
                :class="[scrollTop > 100 ? 'active2' : 'active']"
              >
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/news"
                  >新闻动态</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/contact"
                  >联系我们</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/hire"
                  >人才招聘</router-link
                >
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
    <div class="spacebox"></div>
    <main>
      <!-- 顶部图 -->
      <div class="pictureBox" v-if="picture">
        <img :src="picture.P_IMG" />
      </div>

      <!-- 新闻详情 -->
      <div class="news container" v-if="news">
        <div class="top">
          <div class="name">{{ news.INFO_TITLE }}</div>
          <div class="time">{{ news.CREATEDATE }}</div>
          <div class="topline"></div>
        </div>
        <div class="newsCont" v-html="news.INFO_INTRODUCE"></div>
      </div>
    </main>
    <bottomFooter />
  </div>
</template>

<style>
.news {
  /* padding-bottom: 5.6875rem; */
  padding-bottom: 3.8125rem;
}

.news .newsCont {
  width: 100%;
  text-align: left;
  padding-top: 4.125rem;
}

.news .newsCont img {
  max-width: 100%;
}

.news .top {
  width: 100%;
  text-align: left;
}

.top .name {
  width: 100%;
  line-height: 2.375rem;
  font-size: 1.625rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  margin: 3.125rem 0 2.25rem;
}

.top .time {
  width: 100%;
  line-height: 0.75rem;
  font-size: 1rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-bottom: 2.5625rem;
}

.top .topline {
  width: 100%;
  height: 0.25rem;
  background: #020e62;
}

@media (max-width: 992px) {
  .news {
    width: 94% !important;
    margin-left: 3% !important;
    max-width: 900px !important;
  }

  .top .name {
    line-height: 2.1rem !important;
    font-size: 1.4rem !important;
    margin: 3.1rem 0 2.3rem !important;
  }
}

@media (max-width: 770px) {
  .news {
    width: 90% !important;
    margin-left: 5% !important;
    margin-right: 5% !important;
  }

  .top .name {
    line-height: 2rem !important;
    font-size: 1.35rem !important;
    margin: 2.7rem 0 2.1rem !important;
  }

  .news .newsCont {
    padding-top: 3.8rem !important;
  }

  .news .newsCont img {
    width: 80%;
    max-width: 100%;
  }
}

@media (max-width: 600px) {
  .news {
    width: 90% !important;
    margin-left: 5% !important;
    margin-right: 5% !important;
  }

  .top .time {
    line-height: 0.75rem;
    font-size: 1rem;
    margin-bottom: 2rem;
  }

  .news .newsCont {
    padding-top: 3.2rem !important;
  }
}

@media (max-width: 499px) {
  .news {
    width: 100% !important;
    padding-left: 2% !important;
    padding-right: 2% !important;
    padding-bottom: 2rem;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .top .name {
    margin: 2rem 0 1.4rem !important;
  }

  .top .time {
    line-height: 0.75rem;
    font-size: 1rem;
    margin-bottom: 1.4rem;
  }

  .news .newsCont {
    padding-top: 2.5rem !important;
  }
}
</style>
<script>
import bottomFooter from "@/components/bottomFooter.vue";
import { getBackground, getNewsDetail } from "../api/interface"; // 引入接口
export default {
  name: "newsDetail",
  components: {
    bottomFooter,
  },
  data() {
    return {
      backgroundColor: "",
      fontColor: "",
      scrollTop: 0,
      news: null,
      picture: null,
      showView: false,
      isCollapse: true, //是否折叠导航条
      bgimg1: require("../assets/collapse.png"),
      bgimg2: require("../assets/close1.png"),
    };
  },

  created() {
    console.log(this.$route.query.id);
    let DB_INFORMATION_ID = this.$route.query.id;
    this.getImg();
    this.getNewsDetail(DB_INFORMATION_ID);
  },

  mounted() {
    //首先，在mounted钩子window添加一个滚动滚动监听事件
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    //然后在方法中，添加这个handleScroll方法来获取滚动的位置
    handleScroll() {
      // let scrollTop =
      //   window.pageYOffset ||
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop;
      let scrollTop = document.documentElement.scrollTop;

      console.log("scrollTop", scrollTop);

      //设置页面滚动时目录导航栏的背景颜色
      if (scrollTop > 100) {
        this.$set(this, "scrollTop", scrollTop);
        this.$set(this, "backgroundColor", "#fff");
        this.$set(this, "fontColor", "#000000!important");
      } else {
        this.$set(this, "scrollTop", scrollTop);
        this.$set(this, "backgroundColor", "rgba(0, 0, 0, 0.1)");
        this.$set(this, "fontColor", "#ffffff");
      }
    },

    // 折叠导航栏
    collapseNav() {
      const that = this;
      that.$set(that, "isCollapse", !that.isCollapse);
    },

    // 获取图片数据
    async getImg() {
      const that = this;
      await getBackground({ P_INFO: "news-update" }).then((res) => {
        console.log(res);
        if (res.state == "success") {
          that.$set(that, "picture", res.picture);
          if (that.picture != null) {
            that.$set(that, "showView", true);
          }
        }
      });
    },

    // 获取新闻列表
    async getNewsDetail(DB_INFORMATION_ID) {
      const that = this;
      await getNewsDetail({ DB_INFORMATION_ID: DB_INFORMATION_ID }).then(
        (res) => {
          console.log(res);
          that.$set(that, "news", res.information);
        }
      );
    },
  },

  //由于是在整个window中添加的事件，所以要在页面离开时摧毁掉，否则会报错
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
